// extracted by mini-css-extract-plugin
export var collapsedSummary = "_ng-0";